import { Typography } from '@mui/material';

import { SlaStatus } from '../../../api/enumerations';
import {
  IconTaskAltMS,
  IconTimelapseMS,
  IconWarningMS,
} from '../../../constants/icons';
import {
  DeadlineTrackingProps,
  useDeadlineProgress,
} from './hooks/useDeadlineProgress';
import {
  DeadlineTextBox,
  LabelBox,
  NotificationBox,
  ProgressBar,
  ProgressBox,
  ProgressFill,
  ProgressLabel,
} from './styles';

type DeadlineStyleConfig = {
  icon: JSX.Element;
  text: string | null;
  description: string;
  color: string;
};

const DEADLINE_STYLE_CONFIG: Record<SlaStatus, DeadlineStyleConfig> = {
  on_track: {
    icon: IconTaskAltMS,
    text: null,
    description: 'Esta OS está dentro do prazo de execução.',
    color: '#62aa41',
  },
  near_deadline: {
    icon: IconTimelapseMS,
    text: '{{remaining}} dia(s) restante(s)',
    description:
      'Esta OS está próxima do vencimento. Finalize o mais rápido possível.',
    color: '#E67715',
  },
  overdue: {
    icon: IconWarningMS,
    text: 'Prazo expirado há {{remaining}} dia(s)',
    description: 'Esta OS ultrapassou o prazo de execução.',
    color: '#F50606',
  },
};

export function HiveDeadlineBar(
  props: DeadlineTrackingProps
): JSX.Element | null {
  const { slaStatus, slaDaysRemaining } = props;
  const { progressPercent } = useDeadlineProgress(props);

  if (slaStatus === null) return null;

  const remainingDays = Math.abs(slaDaysRemaining ?? 0).toString();
  const styleConfig = DEADLINE_STYLE_CONFIG[slaStatus];

  return (
    <NotificationBox color={styleConfig.color}>
      <LabelBox>
        {styleConfig.icon}
        <DeadlineTextBox color={styleConfig.color}>
          <Typography className="bold">
            {styleConfig.text &&
              styleConfig.text.replace('{{remaining}}', remainingDays)}
          </Typography>
          <Typography>{styleConfig.description}</Typography>
        </DeadlineTextBox>
      </LabelBox>
      <ProgressBox>
        <ProgressLabel>
          <Typography>Progresso do prazo</Typography>
          <Typography>{Math.round(progressPercent)}%</Typography>
        </ProgressLabel>
        <ProgressBar>
          <ProgressFill
            color={styleConfig.color}
            style={{ width: `${progressPercent}%` }}
          />
        </ProgressBar>
      </ProgressBox>
    </NotificationBox>
  );
}
